export interface SearchResultExpanderItemProps {
	count: number;
}

export const SearchResultExpanderItem = (props: SearchResultExpanderItemProps) => {
	const { count } = props;

	return <div className="px-2.5 py-1.5 font-normal leading-4 text-xs">...{count} more</div>;
};
